export const AUTOCOMPLETE_MINIMUM_LENGTH = {
    TANK: 2,
    SALES_ORDER: 3,
};
